import React from 'react';
import Client from './client';
import DeliveryDetails from './map/delivery-details';
import ClientLoading from './skeletons/client-loading';
import Instructions from './instructions';
import Modal from './modal';
import config from '../config';
import authService from '../services/auth';
import { useBookingData } from '../context/BookingContext';
import { useUIStore } from '../stores/ui-store';

const ClientPanel = () => {

    const auth = authService.getToken();

    const { booking, loading } = useBookingData();
    const documentId = booking?.documentId || '';

    // Use Zustand for modal state
    const modalOpen = useUIStore((state) => state.modalOpen);
    const closeModal = useUIStore((state) => state.closeModal);

    return (
        <div className="w-full lg:w-3/5 lg:min-h-screen lg:h-screen flex flex-col sm:flex-row">
            <div className="w-full sm:w-1/12 flex justify-center sm:block">
                <img className="ml-0 sm:ml-8 pt-6 w-16 sm:w-auto" src="/logo-192x192.png" alt="Rubbish Direct Logo" />
            </div>
            <div className="w-full sm:w-11/12 px-4 sm:px-0">
                {loading ? <ClientLoading /> : <Client />}
                <DeliveryDetails />
                <Modal
                    height="h-screen"
                    width="w-full md:w-4/5 lg:w-3/5"
                    show={modalOpen}
                    closeModal={closeModal}
                >
                    { documentId !== "" ? <embed src={`${config.documentsUrl}DocumentManager?a=get-file&fid=${documentId}&uz=${auth}`}
                        height="600"
                        width="100%"
                        className="mx-auto"
                    ></embed> : null
                    }

                    <div className="border-t">
                        <Instructions />
                    </div>
                </Modal>
            </div>
        </div>
    )
}

export default ClientPanel;
